import { Button, ButtonIcon } from "@repo/components/src/ui/button";
import * as DocumentPicker from "expo-document-picker";
import { DocumentPickerAsset } from "expo-document-picker";
import { Paperclip } from "lucide-react-native";
import React from "react";
import { ActionsProps } from "@kesha-antonov/react-native-chat";

type ExtendedActionsProps = ActionsProps & {
  setDocumentPicker: React.Dispatch<
    React.SetStateAction<DocumentPickerAsset | null>
  >;
};

export default function GiftedChatActions(props: ExtendedActionsProps) {
  const { setDocumentPicker } = props;
  const handleUpload = async () => {
    const result = await DocumentPicker.getDocumentAsync({
      type: ["image/*", "video/*", "application/*"],
    });
    if (!result.canceled) {
      setDocumentPicker(result.assets[0]);
    }
  };
  return (
    <Button
      variant="link"
      action="muted"
      size="circle-md"
      rounded="full"
      onPress={handleUpload}
      className="data-[hover=true]:bg-background-100 text-typography-500"
    >
      <ButtonIcon as={Paperclip} className="text-typography-500" />
    </Button>
  );
}
